import { render } from "./ContractListV3.vue?vue&type=template&id=36d7fe66&scoped=true"
import script from "./ContractListV3.vue?vue&type=script&lang=js"
export * from "./ContractListV3.vue?vue&type=script&lang=js"

import "./ContractListV3.vue?vue&type=style&index=0&id=36d7fe66&scoped=true&lang=css"
import "./ContractListV3.vue?vue&type=style&index=1&id=36d7fe66&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36d7fe66"]])

export default __exports__